module.exports = __webpack_public_path__ + "img/faq-illustrations.a0f26485.svg";